// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Marker Creation Popup - Theme-Aware */

.marker-creation-popup {
  background: var(--cfn-popup-bg);
  border-radius: 12px;
  box-shadow: var(--cfn-popup-shadow);
  border: 1px solid var(--cfn-border);
  min-width: 280px;
  max-width: 320px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--cfn-text-primary);
}

/* Header */
.marker-creation-popup__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-header-bg);
  border-left: 3px solid var(--cfn-accent-primary);
  border-radius: 12px 12px 0 0;
}

.marker-creation-popup__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--cfn-btn-primary-bg);
  box-shadow: var(--cfn-shadow-md);
  flex-shrink: 0;
}

.marker-creation-popup__icon i {
  font-size: 18px;
  color: #ffffff;
}

.marker-creation-popup__title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--cfn-text-primary);
}

.marker-creation-popup__coords {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: var(--cfn-text-muted);
  font-family: 'Courier New', monospace;
}

/* Actions Grid */
.marker-creation-popup__actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 12px;
}

/* Action Buttons */
.marker-creation-popup__action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 8px;
  border: 1px solid var(--cfn-border);
  border-radius: 8px;
  background: var(--cfn-btn-secondary-bg);
  color: var(--cfn-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.marker-creation-popup__action-btn:hover {
  transform: translateY(-2px);
  background: var(--cfn-btn-secondary-hover-bg);
  border-color: var(--cfn-border-strong);
  box-shadow: var(--cfn-shadow-md);
}

.marker-creation-popup__action-btn i {
  font-size: 20px;
}

/* Button Variants */
.marker-creation-popup__action-btn--primary {
  background: var(--cfn-accent-primary-muted);
  border-color: var(--cfn-btn-primary-border);
}

.marker-creation-popup__action-btn--primary:hover {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-accent-primary);
  color: var(--cfn-btn-primary-text);
  box-shadow: 0 4px 12px var(--cfn-focus-ring);
}

.marker-creation-popup__action-btn--danger {
  background: var(--cfn-danger-muted);
  border-color: var(--cfn-btn-danger-border);
  color: var(--cfn-danger-text);
}

.marker-creation-popup__action-btn--danger:hover {
  background: var(--cfn-btn-danger-hover-bg);
  border-color: var(--cfn-danger);
}

/* Leaflet popup wrapper */
.leaflet-popup-content-wrapper.marker-creation-popup-wrapper {
  background: transparent;
  padding: 0;
  box-shadow: none;
  border-radius: 12px;
}

.leaflet-popup-content-wrapper.marker-creation-popup-wrapper .leaflet-popup-content {
  margin: 0;
  width: auto !important;
}

.leaflet-popup-tip-container.marker-creation-popup-tip {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/marker-creation-popup.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,8EAA8E;EAC9E,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Marker Creation Popup - Theme-Aware */\n\n.marker-creation-popup {\n  background: var(--cfn-popup-bg);\n  border-radius: 12px;\n  box-shadow: var(--cfn-popup-shadow);\n  border: 1px solid var(--cfn-border);\n  min-width: 280px;\n  max-width: 320px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--cfn-text-primary);\n}\n\n/* Header */\n.marker-creation-popup__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-header-bg);\n  border-left: 3px solid var(--cfn-accent-primary);\n  border-radius: 12px 12px 0 0;\n}\n\n.marker-creation-popup__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--cfn-btn-primary-bg);\n  box-shadow: var(--cfn-shadow-md);\n  flex-shrink: 0;\n}\n\n.marker-creation-popup__icon i {\n  font-size: 18px;\n  color: #ffffff;\n}\n\n.marker-creation-popup__title h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--cfn-text-primary);\n}\n\n.marker-creation-popup__coords {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: var(--cfn-text-muted);\n  font-family: 'Courier New', monospace;\n}\n\n/* Actions Grid */\n.marker-creation-popup__actions {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  padding: 12px;\n}\n\n/* Action Buttons */\n.marker-creation-popup__action-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 14px 8px;\n  border: 1px solid var(--cfn-border);\n  border-radius: 8px;\n  background: var(--cfn-btn-secondary-bg);\n  color: var(--cfn-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.marker-creation-popup__action-btn:hover {\n  transform: translateY(-2px);\n  background: var(--cfn-btn-secondary-hover-bg);\n  border-color: var(--cfn-border-strong);\n  box-shadow: var(--cfn-shadow-md);\n}\n\n.marker-creation-popup__action-btn i {\n  font-size: 20px;\n}\n\n/* Button Variants */\n.marker-creation-popup__action-btn--primary {\n  background: var(--cfn-accent-primary-muted);\n  border-color: var(--cfn-btn-primary-border);\n}\n\n.marker-creation-popup__action-btn--primary:hover {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-accent-primary);\n  color: var(--cfn-btn-primary-text);\n  box-shadow: 0 4px 12px var(--cfn-focus-ring);\n}\n\n.marker-creation-popup__action-btn--danger {\n  background: var(--cfn-danger-muted);\n  border-color: var(--cfn-btn-danger-border);\n  color: var(--cfn-danger-text);\n}\n\n.marker-creation-popup__action-btn--danger:hover {\n  background: var(--cfn-btn-danger-hover-bg);\n  border-color: var(--cfn-danger);\n}\n\n/* Leaflet popup wrapper */\n.leaflet-popup-content-wrapper.marker-creation-popup-wrapper {\n  background: transparent;\n  padding: 0;\n  box-shadow: none;\n  border-radius: 12px;\n}\n\n.leaflet-popup-content-wrapper.marker-creation-popup-wrapper .leaflet-popup-content {\n  margin: 0;\n  width: auto !important;\n}\n\n.leaflet-popup-tip-container.marker-creation-popup-tip {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
